<template>
  <div>
    <Table :columns="columns" :data="resources" size="small" :loading="loading" highlight-row stripe max-height="700"
      :show-summary="true" :summary-method="handleSummary">
      <template slot-scope="{ row }" slot="ending_balance">
        <b>{{ row.ending_balance }}</b>
      </template>
      <template slot-scope="{ row }" slot="totalCostUSD">
        <b>
          {{
            formatCurrency((row.cost_amount ? row.cost_amount : 0))
          }}
        </b>
      </template>
      <template slot-scope="{ row }" slot="totalCostTHB">
        <b>
          {{
            formatCurrency((row.cost_amount ? row.cost_amount * 32 : 0))
          }}
        </b>
      </template>
    </Table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SummaryByGroup',
  props: ['summary'],
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('report/productNonMovingStock', ['resources']),
    columns() {
      return [
        {
          title: this.$t('productNonMovingStock.no'),
          key: 'no',
          width: 70,
          render: (h, params) => {
            return h('span', [params.index + 1])
          }
        },
        {
          title: this.$t('productNonMovingStock.branch'),
          key: 'branch_name_en',
          minWidth: 200
        },
        {
          title: this.$t('productNonMovingStock.wareHouse'),
          key: 'location_name',
          minWidth: 200
        },
        {
          title: this.$t('productNonMovingStock.category'),
          key: 'category',
          minWidth: 250
        },
        {
          title: this.$t('productNonMovingStock.group'),
          key: 'product_group',
          minWidth: 250
        },
        {
          title: this.$t('productNonMovingStock.balance'),
          slot: 'ending_balance',
          key: 'ending_balance',
          minWidth: 150,
          align: 'center'
        },
        {
          title: this.$t('productNonMovingStock.totalCostUSD'),
          slot: 'totalCostUSD',
          key: 'totalCostUSD',
          minWidth: 200,
          align: 'right',
        },
        {
          title: this.$t('productNonMovingStock.totalCostTHB'),
          slot: 'totalCostTHB',
          key: 'totalCostTHB',
          minWidth: 200,
          align: 'right'
        }
      ]
    }
  },
  methods: {
    formatCurrency(amount) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
      }).format(amount)
    },
    handleSummary({ columns, data }) {
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (index === 2) {
          sums[key] = {
            key,
            value: this.$t('productNonMovingStock.total')
          }
          return
        }
        const values = data.map(item => Number(item[key]))
        if (key === 'category') {
          sums[key] = {
            key,
            value: this.summary.total_category
          }
        } else if (key === 'product_group') {
          sums[key] = {
            key,
            value: this.summary.total_group
          }
        } else if (key === 'ending_balance') {
          sums[key] = {
            key,
            value: this.summary.total_ending_balance
          }
        } else if (key === 'totalCostUSD') {
          const sumTotalUSD = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
          }).format(this.summary.total_cost_amount_usd)

          sums[key] = {
            key,
            value: sumTotalUSD
          }
        } else if (key === 'totalCostTHB') {
          const sumTotalTBH = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
          }).format(this.summary.total_cost_amount_bath)

          sums[key] = {
            key,
            value: sumTotalTBH
          }
        } else {
          sums[key] = {
            key,
            value: ''
          }
        }
      })

      return sums
    }
  }
}

</script>
<style>
.ivu-table-summary .ivu-table-cell {
  font-weight: bold;
}
</style>